import PropTypes from "prop-types";
import "app/pages/.shared/Page/page.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { PAGE_TYPE } from "app/constants";
import classNames from "classnames";

const Page = ({ title, variant, children }) => {
	const pageClassname = classNames("page", {
		"page--gradient": variant === PAGE_TYPE.GRADIENT,
	});

	return (
		<div className={pageClassname}>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				isBold
				className="page__title"
				component="h1"
			>
				{title}
			</Typography>
			<section className="page__content">{children}</section>
		</div>
	);
};

Page.propTypes = {
	variant: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default Page;
